import * as AutoKana from "vanilla-autokana";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-autokana]").forEach((el) => {
    AutoKana.bind(el.getAttribute("id"), el.getAttribute("data-autokana"));
  });
});
